
export const en = {
  // Navigation
  home: 'Home',
  flights: 'Flights',
  hotels: 'Hotels',
  buses: 'Buses',
  cars: 'Cars',
  myTrips: 'My Trips',
  profile: 'Profile',
  
  // Common
  search: 'Search',
  book: 'Book',
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  loading: 'Loading...',
  error: 'Error occurred',
  success: 'Success',
  
  // Auth
  login: 'Login',
  logout: 'Logout',
  register: 'Register',
  email: 'Email',
  password: 'Password',
  forgotPassword: 'Forgot Password?',
  
  // Booking
  from: 'From',
  to: 'To',
  departure: 'Departure',
  arrival: 'Arrival',
  date: 'Date',
  time: 'Time',
  passengers: 'Passengers',
  adults: 'Adults',
  children: 'Children',
  infants: 'Infants',
  
  // Services
  wifi: 'WiFi',
  meals: 'Meals',
  baggage: 'Baggage',
  entertainment: 'Entertainment',
  
  // Language
  language: 'Language',
  arabic: 'العربية',
  english: 'English'
};
